import { Table } from '@mantine/core';

import { goodsTypes } from '../../types';

import { BodyRow } from './BodyRow';

import { Departments } from '@/types';

type GoodsTableProps = {
  department: Departments;
  goods: goodsTypes.Item[];
};

export const GoodsTable = ({ department, goods }: GoodsTableProps) => {
  return (
    <Table stickyHeader striped highlightOnHover>
      <Table.Thead>
        <Table.Tr>
          <Table.Th>Название</Table.Th>
          <Table.Th>Ключ</Table.Th>
          <Table.Th>Действия</Table.Th>
        </Table.Tr>
      </Table.Thead>
      <Table.Tbody>
        {goods?.map((item) => <BodyRow key={item._id} department={department} item={item} />)}
      </Table.Tbody>
    </Table>
  );
};
